import React, { FC } from 'react';
import { HistoricalScore, HistoricalScoreTooltip, ProgressBarCont } from './ProgressBar.styles';

interface IProgressBar {
  barMode: 'weak' | 'normal' | 'strong';
  historicalScore?: number;
  progress: string;
  height: string;
  contWidth?: string;
  background?: string;
  tooltip?: string;
  tooltipWidth?: number;
}

const ProgressBar: FC<IProgressBar> = ({
  barMode,
  historicalScore,
  progress,
  height,
  contWidth,
  background,
  tooltip,
  tooltipWidth = 140,
}) => (
  <ProgressBarCont
    contWidth={contWidth}
    height={height}
    data-testid="progressBar"
    width={progress}
    barMode={barMode}
    background={background}
  >
    {historicalScore && tooltip ? (
      <HistoricalScoreTooltip
        contWidth={contWidth}
        historicalScore={historicalScore}
        tooltipDesc={tooltip}
        position="top"
        positionX={`-${tooltipWidth / 2}px`}
        positionY={`${parseInt(height, 10) + 4}px`}
        arrowPositionX={`${tooltipWidth / 2 - 3}px`}
        width={`${tooltipWidth}px`}
      >
        <HistoricalScore height={height} />
      </HistoricalScoreTooltip>
    ) : null}
  </ProgressBarCont>
);

export default ProgressBar;
